(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase', {
            parent: 'entity',
            url: '/purchase?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchase.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase/purchases.html',
                    controller: 'PurchaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchase');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-detail', {
            parent: 'entity',
            url: '/purchase/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchase.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase/purchase-detail.html',
                    controller: 'PurchaseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchase');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Purchase', function($stateParams, Purchase) {
                    return Purchase.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase.new', {
            parent: 'purchase',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase/purchase-dialog.html',
                    controller: 'PurchaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                issueDate: null,
                                desirableExecutionDate: null,
                                shippingAddressNum: null,
                                shippingAddress: null,
                                shippingCityName: null,
                                shippingPrefectureName: null,
                                shippingRegionName: null,
                                shippingCountryName: null,
                                shippingPostalCode: null,
                                netPrice: null,
                                discountPrice: null,
                                totalPrice: null,
                                taxPrice: null,
                                finalPrice: null,
                                comment: null,
                                previousBalance: null,
                                creditLimit: null,
                                newBalance: null,
                                discountPercent: null,
                                presentPrice: null,
                                sectorAddressNum: null,
                                sectorAddress: null,
                                sectorCityName: null,
                                sectorPrefectureName: null,
                                sectorRegionName: null,
                                sectorCountryName: null,
                                sectorPostalCode: null,
                                code: null,
                                presentPercent: null,
                                discountFinalPrice: null,
                                createdFromBackOffice: null,
                                eventComments: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase', null, { reload: true });
                }, function() {
                    $state.go('purchase');
                });
            }]
        })
        .state('purchase.edit', {
            parent: 'purchase',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase/purchase-dialog.html',
                    controller: 'PurchaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Purchase', function(Purchase) {
                            return Purchase.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase.delete', {
            parent: 'purchase',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase/purchase-delete-dialog.html',
                    controller: 'PurchaseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Purchase', function(Purchase) {
                            return Purchase.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
